module.exports = __webpack_public_path__ + "img/128.10.e532034c.png";